<template>
  <div>
    <Breadcrumbs title="관리자 등록" main="관리자" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="col-8 d-flex justify-content-between">
                <h5>관리자 등록</h5>
              </div>
            </div>
            <div class="card-body">
              <form class="needs-validation" novalidate="" @submit.prevent="validationSubmit">
                <div class="d-flex col-12 mb-3">
                  <div class="d-flex align-items-center col-4 me-4">
                    <div class="col-2 form-label validation-name">아이디</div>
                    <div class="col-9">
                      <input class="form-control btn-square" v-bind:class="formSubmitted ? idError ? 'is-invalid' : 'is-valid' : ''" type="text" v-model="adminId"/>
                      <div class="invalid-feedback" v-if="error.userId">{{error.userId}}</div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center col-4">
                    <div class="col-2 validation-name">비밀번호</div>
                    <div class="col-9">
                      <input class="form-control btn-square" v-bind:class="formSubmitted ? pwError ? 'is-invalid' : 'is-valid' : ''" type="password" v-model="adminPassword"/>
                      <div class="invalid-feedback" v-if="error.password">{{error.password}}</div>
                    </div>
                  </div>
                </div>
                <div class="d-flex col-12 mb-3">
                  <div class="d-flex align-items-center col-4 me-4">
                    <div class="col-2 validation-name">이름</div>
                    <div class="col-9">
                      <input class="form-control btn-square" v-bind:class="formSubmitted ? nameError ? 'is-invalid' : 'is-valid' : ''" type="text" v-model="adminName"/>
                      <div class="invalid-feedback" v-if="error.name">{{error.name}}</div>
                    </div>
                  </div>
                </div>
                <div class="d-flex col-12 mb-3">
                  <div class="d-flex align-items-center col-4 me-4">
                    <div class="col-2 validation-name">휴대폰번호</div>
                    <div class="col-9">
                      <input class="form-control btn-square" v-bind:class="formSubmitted ? phoneError ? 'is-invalid' : 'is-valid' : ''" type="text" maxlength="14" v-model="adminPhoneNo" @input="handlePhoneNo"/>
                      <div class="invalid-feedback" v-if="error.phoneNo">{{error.phoneNo}}</div>
                    </div>
                  </div>
                </div>
                <div v-if="error.message" class="error">{{ error.message }}</div>
                <div class="col-8 d-flex justify-content-center">
                  <button class="btn btn-outline-light" type="submit">등록</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router'
import { useLoginAuth } from '@/stores/LoginAuthStore'
import useAdminRegistry from '@/composables/registerAdmin'
const router = useRouter()
const LoginAuthStore = useLoginAuth(router)
const {adminId, adminPassword, adminName, adminPhoneNo, error, saveAdmin}  = useAdminRegistry(LoginAuthStore)

const formSubmitted = ref(false);
const idError = ref(false);
const pwError = ref(false);
const nameError = ref(false);
const phoneError = ref(false);

const handlePhoneNo = (e) => {
  if (e.target.value.replace(/[^0-9]/g, '').length === 12) {
    adminPhoneNo.value = e.target.value.replace(/[^0-9]/g, '').replace(/^(\d{4})(\d{4})(\d{4})$/, `$1-$2-$3`);
  } else {
    adminPhoneNo.value = e.target.value.replace(/[^0-9]/g, '').replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  }
}

const validationSubmit = () => {
  formSubmitted.value = true;
  if (adminId.value.length < 1) idError.value = true;
  else idError.value = false;
  
  if (adminPassword.value.length < 1) pwError.value = true;
  else pwError.value = false;

  if (adminName.value.length < 1) nameError.value = true;
  else nameError.value = false;

  if (adminPhoneNo.value.length < 9 || adminPhoneNo.value.length > 13) phoneError.value = true;
  else phoneError.value = false;

  saveAdmin(router);
}
</script>
<style lang="scss">
.validation-name {
  color: #d72e3c;
}
</style>